import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-right" }
const _hoisted_2 = { class: "text-right" }

import moment from "moment";
import ConfirmDialog from "primevue/confirmdialog";
import DataTable from "primevue/datatable";
import Button from "primevue/button";
import Column from "primevue/column";
import Panel from 'primevue/panel'
import {inject, onMounted, ref} from "vue";
import {AxiosStatic} from "axios";
import {Billing, SelectedMonthType} from "@/components/blocks/Types";
import {formatWorkTime, formatPrice} from "@/services/FormatService";
import ClickIcon from "@/components/blocks/ClickIcon.vue";
import {useConfirm} from "primevue/useconfirm";
import {useRouter} from "vue-router";
import MonthSelector from "@/components/blocks/MonthSelector.vue";
import {previousMonth, buildMoment} from "@/components/blocks/Functions";

// Define injects

export default /*#__PURE__*/_defineComponent({
  __name: 'BillingListTable',
  setup(__props) {


const axios = inject<AxiosStatic>('axios')

// Define properties
const items = ref<Billing[]>([])
const loading = ref<boolean>(true)
const dt = ref(null);
const pageIndex = ref<number>(0)
const pageSize = ref<number>(25)
const totalRecords = ref<number>(0)
const confirm = useConfirm()
const router = useRouter()
const selectedMonth = ref<SelectedMonthType>(previousMonth())

// Define lifecycle hooks
onMounted(() => {
  loadData()
})

// Define methods
function handleClick(input: Billing) {

  confirm.require({
    message: 'Do you want generate invoice for ' + input.companyName + ' with description ' + input.note + ' and price ' + formatPrice(input.earn),
    header: input.companyName + ': Generate Invoice',
    icon: 'pi pi-question-circle',
    accept: () => {
      generateInvoice(input)
    }
  })
}

function generateInvoice(input: Billing) {
  const issueDate = buildMoment(selectedMonth.value).endOf('month').format('YYYY-MM-DD');
  axios?.get('/invoice/v2/generate?companyID='+input.companyId+'&issueDate='+issueDate)
      .then(response=>{
        if (response.status === 200) {
          const invoice = response.data.data
          router.push({
            path: '/private/invoices/' + invoice.id
          })
        } else {
          console.error('Can not generate invoice!')
        }
      })
}

function loadData(filterData: any = {}) {
  loading.value = true
  const issueDate = buildMoment(selectedMonth.value).endOf('month').format('YYYY-MM-DD');
  axios?.get("/billing/list?to="+issueDate)
      .then((response) => {
        if (response.status === 200) {
          items.value = response.data
        }
        totalRecords.value = response.data.length
        loading.value = false
      }).catch(error => {
    console.error('Can not load billing', error)
    loading.value = false
  })
}

function monthSelected(data: SelectedMonthType) {
  loadData()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ConfirmDialog)),
    _createVNode(_unref(Panel), {
      header: "Select month",
      class: "mt-2"
    }, {
      default: _withCtx(() => [
        _createVNode(MonthSelector, {
          modelValue: selectedMonth.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedMonth).value = $event)),
          onChange: monthSelected
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_unref(DataTable), {
      page: pageIndex.value+1,
      ref_key: "dt",
      ref: dt,
      dataKey: "id",
      value: items.value,
      paginator: true,
      rows: pageSize.value,
      totalRecords: totalRecords.value,
      filterDisplay: "row",
      loading: loading.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          field: "companyName",
          header: "COMPANY"
        }),
        _createVNode(_unref(Column), { header: "WORK TIME" }, {
          body: _withCtx(({data}) => [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(formatWorkTime)(data.workTime)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "earn",
          header: "EARN"
        }, {
          body: _withCtx(({data}) => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(formatPrice)(data.earn)), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(Column), {
          field: "note",
          header: "NOTE"
        }),
        _createVNode(_unref(Column), { header: "#" }, {
          body: _withCtx(({data}) => [
            _createVNode(_unref(Button), {
              class: "p-button-sm",
              type: "button",
              onClick: ($event: any) => (handleClick(data))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Create Invoice")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["page", "value", "rows", "totalRecords", "loading"])
  ], 64))
}
}

})